import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { AppLayout } from "./components/AppLayout";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ApiSettings from "./pages/ApiSettings";
import CardVault from "./pages/CardVault";
import ApiKeys from "./pages/ApiKeys";
import CryptoVault from "./pages/CryptoVault";
import AdminMerchants from "./pages/AdminMerchants";
import AuditTrail from "./pages/AuditTrail";
import MyCards from "./pages/cards/MyCards";
import AllCards from "./pages/cards/AllCards";
import NewCard from "./pages/cards/NewCard";
import Wallets from "./pages/Wallets";
import Accounts from "./pages/Accounts";
import Transactions from "./pages/Transactions";

function Protected({ children, adminOnly }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex min-h-screen items-center justify-center bg-background text-sm text-muted-foreground">
        Unlocking vault…
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return <AppLayout>{children}</AppLayout>;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user && user !== null) return <Navigate to="/dashboard" replace />;
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<LoginRoute />} />
              <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
              <Route path="/credentials" element={<Protected><ApiSettings /></Protected>} />
              <Route path="/card-vault" element={<Protected><CardVault /></Protected>} />
              <Route path="/crypto-vault" element={<Protected><CryptoVault /></Protected>} />
              <Route path="/merchants" element={<Protected adminOnly><AdminMerchants /></Protected>} />
              <Route path="/audit" element={<Protected><AuditTrail /></Protected>} />
              <Route path="/cards/all" element={<Protected adminOnly><AllCards /></Protected>} />
              <Route path="/cards/mine" element={<Protected><MyCards /></Protected>} />
              <Route path="/cards/new" element={<Protected><NewCard /></Protected>} />
              <Route path="/developer-keys" element={<Protected><ApiKeys /></Protected>} />
              <Route path="/wallets" element={<Protected><Wallets /></Protected>} />
              <Route path="/accounts" element={<Protected><Accounts /></Protected>} />
              <Route path="/transactions" element={<Protected><Transactions /></Protected>} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
            <Toaster position="top-right" richColors />
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
